export function readPasswordResetTokenFromUrl(url: string | undefined): string {
  if (!url) {
    return '';
  }

  try {
    const parsedUrl = new URL(url);
    const fragmentParams = new URLSearchParams(parsedUrl.hash.replace(/^#/, ''));
    const fragmentToken = fragmentParams.get('token')?.trim();
    return fragmentToken || '';
  } catch {
    return '';
  }
}
